import axios from "@MyAxios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getLinkMetadata = createAsyncThunk(
  'post/getLinkMetadata',
  async ({ link, onSuccess, onError }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/get-link-metadata`, {
        params: { link },
        hideErrorAlert: true
      });
      onSuccess?.(response.data);
      return response.data;

    } catch (error) {
      console.error(error);

      let errorMessage = 'Error retrieving link preview';

      if(typeof error?.response?.data === 'string')
        errorMessage = error?.response?.data;

      if(typeof error?.response?.data?.message === 'string')
        errorMessage = error?.response?.data?.message;

      onError?.(errorMessage);
      return rejectWithValue(error);      
    }
  }
)

export const PostSlice = createSlice({
  name: "post",
  initialState: {
    title: "",
    description: "",
    media: "",
    isGroupOnlyPost: false,
    communities: [],
    connections: [],
    selectedGroups: [],
    selectedPostCommunities: [],
    tags: [],
    fileName: "",
    file: null,
    ageRestricted: false,
    selectedTags: [],

    // for mixed carousel posts
    medias: [],  // contains descriptions and either URLs or OpenGraph metadata
    primaryCarouselItemIndex: -1,

    profileUser: null,
    profilePosts: null,
    profilePostPage: 1,
    profilePostsTotalPages: 15,
  },
  reducers: {
    setTitle: (state, action) => {
      state.title = action.payload;
    },
    setDescription: (state, action) => {
      state.description = action.payload;
    },
    setMedia: (state, action) => {
      state.media = action.payload;
    },
    setFile: (state, action) => {
      state.file = action.payload;
    },
    setAgeRestricted: (state, action) => {
      state.ageRestricted = Boolean(action.payload);
    },
    addToGroups: (state, action) => {
      // Toggle group selection: add if missing, remove if present
      const payload = action.payload;
      if (state.selectedGroups.includes(payload)) {
        state.selectedGroups = state.selectedGroups.filter(
          (id) => id !== payload,
        );
      } else {
        state.selectedGroups.push(payload);
      }
    },
    addToPostCommunities: (state, action) => {
      // NOTE: Written for multiple communities, but used for singular selection
      state.selectedPostCommunities = [ action.payload ];
      // if (state.selectedPostCommunities.includes(action.payload)) {
      //   state.selectedPostCommunities = state.selectedPostCommunities.filter(comId => comId != action.payload);
      // } else {
      //   state.selectedPostCommunities.push(action.payload);
      // }
    },
    addAllToPostCommunities: (state, action) => {
      state.selectedPostCommunities = action.payload;
    },
    addToCommunities: (state, action) => {
      if (state.communities.includes(action.payload)) {
        state.communities.splice(state.communities.indexOf(action.payload), 1);
      } else {
        state.communities.push(action.payload);
      }
    },
    addToConnections: (state, action) => {
      if (state.connections.includes(action.payload)) {
        state.connections.splice(state.connections.indexOf(action.payload), 1);
      } else {
        state.connections.push(action.payload);
      }
    },

    setIsGroupOnlyPost: (state, action) => {
      state.isGroupOnlyPost = action.payload;
    },
    addAllToGroups: (state, action) => {
      const newSet = action.payload;
      state.selectedGroups = newSet;
    },
    addAllToCommunities: (state, action) => {
      const newSet = action.payload;
      state.communities = newSet;
    },
    addAllToConnections: (state, action) => {
      const newSet = action.payload;
      state.connections = newSet;
    },
    clearPostCommunities: (state, action) => {
      state.selectedPostCommunities = [];
    },
    clearGroups: (state, action) => {
      state.selectedGroups = [];
    },
    clearCommunities: (state, action) => {
      state.communities = [];
    },
    clearConnections: (state, action) => {
      state.connections = [];
    },
    setFileName: (state, action) => {
      state.fileName = action.payload;
    },
    setTags(state, action) {
      state.tags = action.payload;
    },
    // carousel
    setMedias(state, action) {
      state.medias = action.payload;
    },
    setPrimaryCarouselItemIndex(state, action) {
      state.primaryCarouselItemIndex = action.payload;
    },
    resetPost: (state, action) => {
      state.title = "";
      state.description = "";
      state.media = "";
      state.communities = [];
      state.connections = [];
      state.selectedGroups = [];
      state.selectedPostCommunities = [];
      state.tags = [];
      state.fileName = "";
      state.file = null;
      state.isGroupOnlyPost = false;
      state.ageRestricted = false;
      state.selectedTags = [];
      // carousel
      state.medias = [];
      state.primaryCarouselItemIndex = 0;
    },
    setProfileUser: (state, action) => {
      state.profileUser = action.payload;
    },
    setProfilePosts: (state, action) => {
      state.profilePosts = action.payload;
    },
    setProfilePostPage: (state, action) => {
      state.profilePostPage = action.payload;
    },
    setProfilePostsTotalPages: (state, action) => {
      state.profilePostsTotalPages = action.payload;
    },
    setSelectedTags: (state, action) => {
      state.selectedTags = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setTitle,
  setAgeRestricted,
  setDescription,
  setMedia,
  setFileName,
  addToCommunities,
  addToConnections,
  clearCommunities,
  clearConnections,
  clearGroups,
  clearPostCommunities,
  addAllToCommunities,
  addAllToConnections,
  resetPost,
  addAllToGroups,
  addToPostCommunities,
  addAllToPostCommunities,
  addToGroups,
  setFile,
  setTags,
  setIsGroupOnlyPost,
  setMedias,
  setPrimaryCarouselItemIndex,
  setProfileUser,
  setProfilePosts,
  setProfilePostPage,
  setProfilePostsTotalPages,
  setSelectedTags
} = PostSlice.actions;

export default PostSlice.reducer;
